module.exports = __webpack_public_path__ + "img/After-Registering-th.b883a1f.png";